import { FormGroup } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { AsiDialogView } from "@asi-ngtools/lib";

@Component({
  selector: 'ajout-filtre-modal',
  templateUrl: './ajout.modal.html',
})
export class AjoutFiltreDialogComponent extends AsiDialogView {

  ajoutForm: FormGroup;
  name : string;

  constructor(private formBuilder: FormBuilder) {
    super();
  }

  ngOnInit() {
    this.ajoutForm = this.formBuilder.group({
      name: [this.name, Validators.required]
    });
    
  }

  close() {
    if (this.ajoutForm.valid) {
      this.dialog.close(this.ajoutForm.value.name);
    }
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/serveur-resultats/filtres/vos-filtres/ajout-modal/ajout.modal.ts